
export default {
  name: "wEmpty",
  inheritAttrs: false,
  props: {
    svg: {
      type: String,
      default: "/media/icons/duotune/files/fil003.svg",
    },
    title: {
      type: String,
      default: "لا يوجد بيانات مسجلة",
    },
  },
};
